// What the marks on the row charts mean, said once for the whole list.
export default function ChartLegend() {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
      <span className="flex items-center gap-1.5">
        <svg width={24} height={12} aria-hidden>
          <path d="M0,2 L12,5 L24,10" fill="none" stroke="var(--primary)" strokeWidth={2} />
        </svg>
        Stock over the buying window
      </span>
      <span className="flex items-center gap-1.5">
        <svg width={12} height={12} aria-hidden>
          <line x1={6} x2={6} y1={0} y2={12} stroke="var(--chart-axis)" strokeDasharray="2 3" />
        </svg>
        Order placed today lands
      </span>
      <span className="flex items-center gap-1.5">
        <svg width={12} height={12} aria-hidden>
          <circle cx={6} cy={6} r={3} fill="var(--destructive)" />
        </svg>
        Stock runs out
      </span>
      <span>Hover a chart for the dates.</span>
    </div>
  )
}
